/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAccountingCtrl.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/accounting-ctrl";

export class AutogenModelAccountingCtrl<RowType extends ModelRow> extends Endpoint<RowType, RowAccountingCtrlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAccountingCtrl extends ModelRow<RowAccountingCtrlFields> {
	constructor(values?: Partial<RowAccountingCtrlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAccountingCtrlFields {
	access_token: string;
	access_token_exp: Date;
	billh_export: string;
	cashreceipts_import: string;
	client_env_type: string;
	client_id: string;
	client_secret: string;
	company_id: string;
	company_name: string;
	connection_timeout: string;
	customer_export: string;
	email_exception: string;
	freight_charge_item_id: string;
	freight_charge_item_name: string;
	gp_company_id: number;
	gp_company_name: string;
	id: number;
	import_customer_status: string;
	import_payee_pay_frequency: string;
	import_payee_pay_method: string;
	import_payee_status: string;
	import_payee_type_of: string;
	import_payment_days_back: number;
	invoice_export_fields: string;
	journal_cash_receipt_export: string;
	journal_driver_export: string;
	journal_sales_export: string;
	payee_export: string;
	realm_id: string;
	refresh_token: string;
	refresh_token_exp: Date;
	settle_agent_export: string;
	settle_carrier_export: string;
	settle_export_bill_number: string;
	settle_oo_export: string;
	time_zone: string;
}

